/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `0` - euler implicit
 * @export
 */
export const TimeIntegrationMethodEnum = {
  EULER_IMPLICIT: 0,
} as const;
export type TimeIntegrationMethodEnum =
  (typeof TimeIntegrationMethodEnum)[keyof typeof TimeIntegrationMethodEnum];

export function instanceOfTimeIntegrationMethodEnum(value: any): boolean {
  for (const key in TimeIntegrationMethodEnum) {
    if (Object.prototype.hasOwnProperty.call(TimeIntegrationMethodEnum, key)) {
      if (TimeIntegrationMethodEnum[key as keyof typeof TimeIntegrationMethodEnum] === value) {
        return true;
      }
    }
  }
  return false;
}

export function TimeIntegrationMethodEnumFromJSON(json: any): TimeIntegrationMethodEnum {
  return TimeIntegrationMethodEnumFromJSONTyped(json, false);
}

export function TimeIntegrationMethodEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): TimeIntegrationMethodEnum {
  return json as TimeIntegrationMethodEnum;
}

export function TimeIntegrationMethodEnumToJSON(value?: TimeIntegrationMethodEnum | null): any {
  return value as any;
}

export function TimeIntegrationMethodEnumToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean
): TimeIntegrationMethodEnum {
  return value as TimeIntegrationMethodEnum;
}
